import { render, staticRenderFns } from "./TeamRights.vue?vue&type=template&id=3ea571e4"
import script from "./TeamRights.vue?vue&type=script&lang=ts"
export * from "./TeamRights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports